import { Directive, ViewContainerRef } from '@angular/core';

@Directive({
  selector: '[staticPageHost]',
})
export class StaticPageDirective {
  constructor(public viewContainerRef: ViewContainerRef) {}
}
